<template>
  <div class="product-category-content">
    <div class="toolbar">
      <el-input
        v-model="searchQuery"
        placeholder="搜索分类名称..."
        style="width: 300px"
        @input="filterData"
        clearable
      >
        <template #prefix>
          <el-icon><Search /></el-icon>
        </template>
      </el-input>
      <el-button type="primary" @click="showAddModal">新增分类</el-button>
    </div>

    <el-table :data="filteredList" style="width: 100%" border>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="分类名称"></el-table-column>
      <el-table-column prop="icon" label="图标/图片" width="120">
        <template #default="scope">
          <el-image
            v-if="scope.row.icon"
            :src="storageSrc(scope.row.icon)"
            style="width: 50px; height: 50px"
            fit="cover"
          ></el-image>
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="deleteItem(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-model="showModal"
      :title="isEditing ? '编辑产品分类' : '新增产品分类'"
      width="500px"
    >
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="图标/图片" prop="icon">
          <el-upload
            class="upload-demo"
            action=""
            accept="image/*"
            :show-file-list="false"
            :http-request="handleIconHttpRequest"
            :before-upload="beforeIconUpload"
            :limit="1"
            list-type="picture-card"
            :disabled="uploading"
          >
            <el-icon v-if="!formData.icon && !uploading" class="upload-icon"><Plus /></el-icon>
            <el-icon v-if="uploading" class="upload-icon is-loading"><Loading /></el-icon>
            <el-image v-else-if="formData.icon" :src="storageSrc(formData.icon)" class="upload-image" fit="cover"></el-image>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeModal">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Search, Plus, Loading } from '@element-plus/icons-vue'
import { getProductCategoryList, uploadFile, addProductCategory, updateProductCategory, deleteProductCategory } from '@/api/index'
import { getUploadRelativePath, getStorageFileUrl, compressImageIfNeeded } from '@/utils/upload'

export default {
  name: 'ProductCategory',
  components: {
    Search,
    Plus,
    Loading
  },
  data() {
    return {
      searchQuery: '',
      showModal: false,
      isEditing: false,
      list: [],
      filteredList: [],
      uploading: false,
      submitting: false,
      formData: {
        id: null,
        name: '',
        icon: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    storageSrc(path) {
      return getStorageFileUrl(path)
    },
    async loadData() {
      try {
        const res = await getProductCategoryList()
        console.log('getProductCategoryList--->', res)
        console.log('res.data--->', res.data)
        
        let dataList = []
        
        if (res.data && Array.isArray(res.data)) {
          dataList = res.data
        } else if (res.data && res.data.list && Array.isArray(res.data.list)) {
          dataList = res.data.list
        } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
          dataList = res.data.data
        } else if (res.data && res.data.items && Array.isArray(res.data.items)) {
          dataList = res.data.items
        }
        
        console.log('解析后的数据列表--->', dataList)
        this.list = dataList
        this.filteredList = [...this.list]
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      }
    },
    filterData() {
      if (!this.searchQuery) {
        this.filteredList = [...this.list]
      } else {
        this.filteredList = this.list.filter(item => 
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      }
    },
    showAddModal() {
      this.isEditing = false
      this.formData = {
        id: null,
        name: '',
        icon: ''
      }
      this.showModal = true
    },
    editItem(item) {
      this.isEditing = true
      this.formData = { ...item }
      this.showModal = true
    },
    async deleteItem(id) {
      this.$confirm('确定要删除这条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteProductCategory(id)
          await this.loadData()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败!')
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    beforeIconUpload(file) {
      const raw = file.raw != null ? file.raw : file
      if (!raw.type || !String(raw.type).includes('image')) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      return true
    },
    async handleIconHttpRequest(options) {
      const rawFile = options.file.raw != null ? options.file.raw : options.file
      this.uploading = true
      try {
        if (rawFile.size > 2 * 1024 * 1024) {
          this.$message.info('图片较大，正在压缩…')
        }
        const fileToUpload = await compressImageIfNeeded(rawFile)
        const formData = new FormData()
        formData.append('file', fileToUpload)
        const res = await uploadFile(formData)
        const relPath = getUploadRelativePath(res)
        if (!relPath) {
          throw new Error('服务器未返回图片路径')
        }
        this.formData.icon = relPath
        if (typeof options.onSuccess === 'function') {
          options.onSuccess(res)
        }
        this.$message.success('图片上传成功!')
      } catch (error) {
        console.error('上传失败:', error)
        if (typeof options.onError === 'function') {
          options.onError(error)
        }
        this.$message.error('图片上传失败!')
      } finally {
        this.uploading = false
      }
    },
    async handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            if (this.isEditing) {
              await updateProductCategory(this.formData)
              this.$message.success('编辑成功!')
            } else {
              await addProductCategory(this.formData)
              this.$message.success('新增成功!')
            }
            await this.loadData()
            this.closeModal()
          } catch (error) {
            console.error('操作失败:', error)
            this.$message.error(this.isEditing ? '编辑失败!' : '新增失败!')
          } finally {
            this.submitting = false
          }
        }
      })
    },
    closeModal() {
      this.showModal = false
      this.formData = {
        id: null,
        name: '',
        icon: ''
      }
    }
  }
}
</script>

<style scoped>
.product-category-content {
  height: 100%;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.upload-demo {
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
}

.upload-demo:hover {
  border-color: #409eff;
}

.upload-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.upload-icon.is-loading {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.upload-image {
  width: 148px;
  height: 148px;
  display: block;
}
</style>
